import { activeStepEpics } from './activeStep';

export default [...activeStepEpics];
